import React from 'react'
import './signup.css'

function Signup() {
  return (
    <div>
        <h1>Signup</h1>
      
    </div>
  )
}

export default Signup
